export enum ElementAttributionCategoryType {
  ITEM = 'item',
  TEXT = 'text'
}
